import React from 'react';
import { Route, Redirect, withRouter } from 'react-router-dom';

import { dashboardRoutePaths } from '../../constants';

import { getQuery } from '../../../../utils';

import { propTypes, defaultProps } from './props';

class FamilyLeaderRoute extends React.Component {
  render() {
    const {
      path,
      Component,
      ledFamilies,
      location,
      ...props
    } = this.props;

    const id = getQuery(location.search, 'id');
    const accessAllowed = id ? !!ledFamilies[id] : false;

    return (
      <Route path={path} render={() => (
        accessAllowed ?
          <Component {...props} /> :
          <Redirect to={dashboardRoutePaths.familiesId(id)} />
      )} />
    );
  }
}

FamilyLeaderRoute.propTypes = propTypes;
FamilyLeaderRoute.defaultProps = defaultProps;

export default withRouter(FamilyLeaderRoute);
